var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMolecules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33348 1.33325V5.33325C9.33339 5.55691 9.38955 5.77699 9.49681 5.97325L13.1701 12.6933C13.2813 12.8963 13.3376 13.1248 13.3336 13.3563C13.3296 13.5877 13.2654 13.8141 13.1474 14.0133C13.0293 14.2124 12.8614 14.3773 12.6603 14.4919C12.4591 14.6064 12.2316 14.6666 12.0001 14.6666H4.00015C3.76866 14.6666 3.54116 14.6064 3.34001 14.4919C3.13886 14.3773 2.971 14.2124 2.85294 14.0133C2.73488 13.8141 2.6707 13.5877 2.6667 13.3563C2.66271 13.1248 2.71903 12.8963 2.83015 12.6933L6.50348 5.97325C6.61074 5.77699 6.66691 5.55691 6.66681 5.33325V1.33325",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30176 10H11.6978",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 1.33325H10.3332",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolecules);
export default __webpack_public_path__ + "static/media/molecules.78c768df8dbf38db0d5ccc02ce98161b.svg";
export { ForwardRef as ReactComponent };